import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from "axios";

export default function ProjectOther() {
    const navigate = useNavigate();
    const { slug } = useParams();
    const [data, setData] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${BaseUrl}/api/project/${slug}`);
          setData(response.data.data);
          if(response.error){
            navigate("/404")
          }
        } catch (error) {
          console.error("Error fetching blog data:", error);
        }
      };
  
      fetchData();
    }, [slug]);

  return (
    <>
    <section className="project-next">
          <div className="container">
              <div className="row">

                  <div className="col-lg-12">
                      <div className="projnext-box">
                        <Link to={`/project/${data?.related_project?.slug}`}>
                            <div>
                                <p>Next Project</p>
                                <h4>{data?.related_project?.title}</h4>
                            </div>
                            <img src={`${BaseUrl}${data?.related_project?.big_listing_image}`} loading="lazy" className="img-responsive" alt="project"/>
                        </Link>
                      </div>
                  </div>

              </div>
          </div>
      </section>
    </>
  )
}
